"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformId = exports._EmbeddedId = exports._ID_SEPARATOR = void 0;
exports.getEmbeddedLabel = getEmbeddedLabel;
exports.plugin = plugin;
exports.mergeIds = mergeIds;
/**
 * @internal
 */
exports._ID_SEPARATOR = ':';
/**
 * @internal
 */
exports._EmbeddedId = 'embedded';
function identify(result, prefix, namespace) {
    for (const key in namespace) {
        const value = namespace[key];
        if (typeof result[key] === 'string') {
            throw new Error(`'identify' overwrites '${key}' for ${prefix}`);
        }
        const ident = prefix + exports._ID_SEPARATOR + key;
        result[key] = typeof value === 'string' ? ident : identify(result[key] ?? {}, ident, value);
    }
    return result;
}
/**
 * @public
 */
function getEmbeddedLabel(str) {
    return (exports._EmbeddedId + exports._ID_SEPARATOR + exports._EmbeddedId + exports._ID_SEPARATOR + str);
}
/**
 * Defines plugin Ids.
 *
 * @public
 * @param plugin -
 * @param namespace -
 * @returns
 */
function plugin(plugin, namespace) {
    return identify({}, plugin, namespace);
}
/**
 * Merges plugin Ids with Ids provided.
 *
 * @public
 * @param plugin -
 * @param ns -
 * @param merge -
 * @returns
 */
function mergeIds(plugin, ns, merge) {
    return identify({ ...ns }, plugin, merge);
}
/**
 * @public
 */
exports.platformId = 'platform';
exports.default = plugin(exports.platformId, {
    status: {
        OK: '',
        BadError: '',
        UnknownError: '',
        InvalidId: '',
        ConnectionClosed: '',
        LoadingPlugin: '',
        NoLocationForPlugin: '',
        ResourceNotFound: '',
        NoLoaderForStrings: '',
        BadRequest: '',
        Forbidden: '', // 403
        Unauthorized: '', // 401
        TokenExpired: '', // 401
        TokenNotActive: '', // 401
        PasswordExpired: '', // 401
        Conflict: '', // 409
        ExpiredLink: '',
        UnknownMethod: '',
        InternalServerError: '',
        MaintenanceWarning: '',
        MaintenanceWarningTime: '',
        AccountNotFound: '',
        AccountMismatch: '',
        AccountNotConfirmed: '',
        WorkspaceNotFound: '',
        WorkspaceArchived: '',
        WorkspaceMigration: '',
        SocialIdNotFound: '',
        SocialIdNotConfirmed: '',
        SocialIdAlreadyConfirmed: '',
        IntegrationExists: '',
        IntegrationAlreadyExists: '',
        IntegrationNotFound: '',
        IntegrationSecretAlreadyExists: '',
        IntegrationSecretNotFound: '',
        PersonNotFound: '',
        InvalidPassword: '',
        PasswordLoginLocked: '',
        AccountAlreadyExists: '',
        PhoneAlreadyExists: '',
        WorkspaceAlreadyExists: '',
        WorkspaceRateLimit: '',
        WorkspaceLimitReached: '',
        InvalidOtp: '',
        InviteNotFound: '',
        MailboxError: '',
        SocialIdAlreadyExists: '',
        ReadOnlyAccount: '',
        RegularAccount: '',
        SystemAccount: '',
        PlanLimitExceeded: ''
    },
    metadata: {
        locale: '',
        LoadHelper: '',
        DevModel: ''
    }
});
//# sourceMappingURL=platform.js.map